import Bugsnag from "@bugsnag/js";
import { IOfferMode } from "@nju/data-access-portal-offers";
import { client } from "@nju/http-client";
import { ISetConsentsResult } from "./types";
import {
  ftthOrchestrator,
  mobileOrchestrator,
  multiOrderOrchestrator,
} from "./validators";

interface IParams {
  orchestratorId: string;
  consents: Array<{
    consentId: string;
    consentVersion: number;
    accepted: boolean;
  }>;
  mode: IOfferMode | "multiOrder";
}

const modeToOrchestratorMap = {
  ftth: ftthOrchestrator,
  mobile: mobileOrchestrator,
  multiOrder: multiOrderOrchestrator,
  postpaid: multiOrderOrchestrator,
} as const;

export async function setConsents({
  orchestratorId,
  consents,
  mode,
}: IParams): Promise<ISetConsentsResult> {
  const serverResponse = modeToOrchestratorMap[mode];
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/CONSENTS_SET`,
    {
      method: "post",
      validator: serverResponse,
      json: {
        consents,
      },
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
